import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { User } from '@sb-shared/models/user';

@Directive({
    selector: 'ng1-profile-groups',
    standalone: false
})
export class ProfileGroupsUpgrade extends UpgradeComponent {
  @Input() selectedPerson: User;
  @Input() isOrganisationAdmin: boolean;
  @Input() isStaff: boolean;
  constructor(elementRef: ElementRef, injector: Injector) {
    super('ng1ProfileGroups', elementRef, injector);
  }
}
